// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__eQd8o","disabled":"FileBtn_disabled__23KEv","warn":"FileBtn_warn__fud__","fade":"FileBtn_fade__6w-PU"};